/*
  Volver a la coleccion.

  La tienda recuerda la ultima coleccion que ha visto la clienta (sessionStorage)
  y la usan:
    - los botones "Continue shopping" del carrito ([data-volver-coleccion]): llevan
      a esa coleccion; si ya esta en ella, solo cierran el cajon;
    - el boton "Back to ..." de la ficha de producto ([data-volver-ficha]): pone el
      enlace y el nombre de la coleccion. Si se viene justo de ella, vuelve atras en
      el historial, que conserva la posicion de la lista.
  El carrito no se pierde al cambiar de pagina: Shopify lo guarda en el servidor.

  window.anColeccion lo pone layout/theme.liquid en las paginas de coleccion.
*/
(() => {
  const CLAVE = 'anUltimaColeccion';
  const POR_DEFECTO = { url: '/collections/best-sellers', titulo: 'Best Sellers' };

  const leer = () => {
    try {
      return JSON.parse(sessionStorage.getItem(CLAVE)) || null;
    } catch (e) {
      return null;
    }
  };

  if (window.anColeccion) {
    try {
      sessionStorage.setItem(
        CLAVE,
        JSON.stringify({ url: location.pathname + location.search, titulo: window.anColeccion.titulo })
      );
    } catch (e) {
      // Sin sessionStorage (modo privado estricto) se usa la coleccion por defecto
    }
  }

  const destino = () => leer() || POR_DEFECTO;

  document.addEventListener('click', (event) => {
    const boton = event.target.closest('[data-volver-coleccion]');
    if (!boton) return;
    event.preventDefault();
    const cajon = boton.closest('cart-drawer');
    if (window.anColeccion && cajon) {
      cajon.close();
      return;
    }
    location.href = destino().url;
  });

  const ponerFicha = () => {
    document.querySelectorAll('[data-volver-ficha]').forEach((enlace) => {
      const d = destino();
      enlace.href = d.url;
      const texto = enlace.querySelector('[data-volver-texto]');
      if (texto) texto.textContent = (window.anTextos?.volverA || 'Back to [title]').replace('[title]', d.titulo);
      enlace.addEventListener('click', (event) => {
        try {
          const ref = new URL(document.referrer);
          if (ref.origin === location.origin && ref.pathname === d.url.split('?')[0] && history.length > 1) {
            event.preventDefault();
            history.back();
          }
        } catch (e) {
          // Sin referrer valido: se sigue el enlace normal
        }
      });
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', ponerFicha);
  } else {
    ponerFicha();
  }
})();
